import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./ContractorsOverviewPage.less');

const ContractorsOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/contractors/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'privateNetwork',
			name: 'Private Network',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/contractors/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/contractors/overview/privateNetwork`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Subcontractors"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="contractorsPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps)(ContractorsOverviewPage));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
